/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateReservationRequestGatewayInfo } from './CreateReservationRequestGatewayInfo';
import {
    CreateReservationRequestGatewayInfoFromJSON,
    CreateReservationRequestGatewayInfoFromJSONTyped,
    CreateReservationRequestGatewayInfoToJSON,
    CreateReservationRequestGatewayInfoToJSONTyped,
} from './CreateReservationRequestGatewayInfo';
import type { CreateReservationRequestReservation } from './CreateReservationRequestReservation';
import {
    CreateReservationRequestReservationFromJSON,
    CreateReservationRequestReservationFromJSONTyped,
    CreateReservationRequestReservationToJSON,
    CreateReservationRequestReservationToJSONTyped,
} from './CreateReservationRequestReservation';

/**
 * 
 * @export
 * @interface CreateReservationRequest
 */
export interface CreateReservationRequest {
    /**
     * 
     * @type {CreateReservationRequestGatewayInfo}
     * @memberof CreateReservationRequest
     */
    gatewayInfo?: CreateReservationRequestGatewayInfo;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    returnUrl?: string;
    /**
     * 
     * @type {CreateReservationRequestReservation}
     * @memberof CreateReservationRequest
     */
    reservation: CreateReservationRequestReservation;
}

/**
 * Check if a given object implements the CreateReservationRequest interface.
 */
export function instanceOfCreateReservationRequest(value: object): value is CreateReservationRequest {
    if (!('reservation' in value) || value['reservation'] === undefined) return false;
    return true;
}

export function CreateReservationRequestFromJSON(json: any): CreateReservationRequest {
    return CreateReservationRequestFromJSONTyped(json, false);
}

export function CreateReservationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'gatewayInfo': json['gatewayInfo'] == null ? undefined : CreateReservationRequestGatewayInfoFromJSON(json['gatewayInfo']),
        'returnUrl': json['returnUrl'] == null ? undefined : json['returnUrl'],
        'reservation': CreateReservationRequestReservationFromJSON(json['reservation']),
    };
}

export function CreateReservationRequestToJSON(json: any): CreateReservationRequest {
    return CreateReservationRequestToJSONTyped(json, false);
}

export function CreateReservationRequestToJSONTyped(value?: CreateReservationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gatewayInfo': CreateReservationRequestGatewayInfoToJSON(value['gatewayInfo']),
        'returnUrl': value['returnUrl'],
        'reservation': CreateReservationRequestReservationToJSON(value['reservation']),
    };
}

